import styled from 'styled-components/macro';

export const IconWrapper = styled.span`
  display: inline-block;
  padding: 2px;
  border-radius: 2px;

  cursor: pointer;

  transition: all 0.1s ease;
  :hover {
    background-color: ${({ theme }) => theme.colors.black_5};

    transition: all 0.2s ease;
    svg path {
      stroke: ${({ theme }) => theme.colors.black_100};
    }
  }
`;
